import { useEffect, useState } from "react";
import * as matrix from "../dienst/matrix";
import { useChat } from "../zustand/ChatZustand";
import { useAnmeldung } from "../zustand/Anmeldung";
import { Abschnitt } from "../bausteine/Grundelemente";
import { Warnung } from "../bausteine/Symbole";
import { kurzesDatum, uhrzeit } from "../hilfen/datum";
import { erneuereKalenderadresse, holeKalenderadresse } from "../dienst/server";

const ROLLEN_TEXT = {
  mitglied: "Mitglied",
  vorsitz: "Fraktionsvorsitz",
  geschaeftsfuehrung: "Fraktionsgeschäftsführung",
  gast: "Gast",
};

export default function Profil({ oeffne }) {
  const { konto, fraktion, bildAdresse, aktionen } = useAnmeldung();

  const [name, setzeName] = useState(konto.name || "");
  const [bild, setzeBild] = useState(null);
  const [meldung, setzeMeldung] = useState("");
  const [fehler, setzeFehler] = useState("");
  const [laeuft, setzeLaeuft] = useState(false);

  async function speichern(e) {
    e.preventDefault();
    setzeFehler("");
    setzeMeldung("");
    setzeLaeuft(true);
    try {
      await aktionen.profilSpeichern({ name: name.trim(), bild });
      setzeBild(null);
      setzeMeldung("Gespeichert.");
    } catch (f) {
      setzeFehler(f.message);
    } finally {
      setzeLaeuft(false);
    }
  }

  const vorschau = bild ? URL.createObjectURL(bild) : bildAdresse;

  return (
    <>
      <div className="detailkopf">
        <p className="detailkopf__vorspann">Dein Konto</p>
        <h1 className="detailkopf__titel">{konto.name || "Profil"}</h1>
        <p className="leise" style={{ marginTop: "var(--luft-2)" }}>
          {ROLLEN_TEXT[konto.rolle] || konto.rolle}
          {fraktion ? ` · ${fraktion.name}, ${fraktion.kommune}` : ""}
        </p>
      </div>

      <Abschnitt titel="Name und Foto" hinweis="So sehen dich die anderen in der Fraktion.">
        <form className="karte" onSubmit={speichern}>
          {fehler && (
            <p className="tor__fehler" style={{ marginBottom: "var(--luft-4)" }} role="alert">
              <Warnung groesse={18} />
              <span>{fehler}</span>
            </p>
          )}
          {meldung && (
            <p className="tor__bestaetigung" style={{ marginBottom: "var(--luft-4)" }}>
              <span>{meldung}</span>
            </p>
          )}

          <div className="feld">
            <span className="feld__name">Vor- und Nachname</span>
            <input
              className="feld__eingabe"
              value={name}
              onChange={(e) => setzeName(e.target.value)}
              autoComplete="name"
            />
          </div>

          <div className="feld" style={{ marginTop: "var(--luft-4)" }}>
            <span className="feld__name">Foto</span>
            <div className="foto">
              {vorschau ? (
                <img className="foto__bild" src={vorschau} alt="" />
              ) : (
                <span className="foto__platzhalter" aria-hidden="true">
                  ?
                </span>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setzeBild(e.target.files[0] || null)}
                style={{ fontSize: "var(--schrift-klein)", flex: 1, minWidth: 0 }}
              />
            </div>
          </div>

          <button className="knopf" style={{ marginTop: "var(--luft-5)" }} disabled={laeuft}>
            {laeuft ? "Wird gespeichert …" : "Speichern"}
          </button>
        </form>
      </Abschnitt>

      <MeineGeraete />

      <Kalenderabo />

      <Chatzugang />

      <Abschnitt titel="Anmeldung" hinweis={`Angemeldet als ${konto.email}`}>
        <div className="karte">
          <p className="klein leise">
            Das Passwort lässt sich derzeit nur über einen Rücksetz-Code ändern.
            Melde dich dafür bei uns.
          </p>
          <button
            className="knopf knopf--zurueckhaltend"
            style={{ marginTop: "var(--luft-4)" }}
            onClick={() => {
              aktionen.abmelden();
              if (oeffne) oeffne("dashboard", {});
            }}
          >
            Abmelden
          </button>
        </div>
      </Abschnitt>
    </>
  );
}


/*
  Der Chat auf dem Handy.

  Das ist der Grund, warum der Chat über Matrix läuft und nicht über unseren
  eigenen Server: Es gibt fertige, verschlüsselte Apps dafür, die auch dann
  benachrichtigen, wenn niemand das Fraktionsbüro geöffnet hat.

  Das Passwort steht bewusst hinter einem Knopf. Es liegt sonst offen auf dem
  Bildschirm, wenn jemand im Ratssaal über die Schulter schaut — und es ist
  ein Passwort, das man nicht ändern kann, weil der Server es führt.
*/
function Chatzugang() {
  const { token } = useAnmeldung();
  const [daten, setzeDaten] = useState(null);
  const [fehler, setzeFehler] = useState("");
  const [laeuft, setzeLaeuft] = useState(false);

  async function zeigen() {
    setzeLaeuft(true);
    setzeFehler("");
    try {
      setzeDaten(await matrix.holeZugangsdaten(token));
    } catch (f) {
      setzeFehler(f.message || "Die Zugangsdaten ließen sich nicht laden.");
    }
    setzeLaeuft(false);
  }

  return (
    <Abschnitt
      titel="Chat auf dem Handy"
      hinweis="Der Chat läuft über Matrix. Du kannst ihn auch in einer eigenen App lesen — etwa Element, kostenlos für iPhone und Android."
    >
      <div className="karte">
        {!daten ? (
          <>
            <p className="klein leise">
              Für die Anmeldung in einer anderen App brauchst du deine Matrix-Zugangsdaten. Das
              Passwort ist ein anderes als deines für das Fraktionsbüro — es gilt nur für den Chat.
            </p>
            <button
              className="knopf knopf--zurueckhaltend"
              style={{ marginTop: "var(--luft-3)" }}
              onClick={zeigen}
              disabled={laeuft}
            >
              {laeuft ? "Einen Moment …" : "Zugangsdaten anzeigen"}
            </button>
            {fehler && (
              <p className="klein" style={{ color: "var(--ampel-nein)", marginTop: "var(--luft-3)" }}>
                {fehler}
              </p>
            )}
          </>
        ) : (
          <>
            <dl className="zugangsdaten">
              <dt>Server</dt>
              <dd>{daten.server}</dd>
              <dt>Benutzername</dt>
              <dd>{daten.kennung}</dd>
              <dt>Passwort</dt>
              <dd>{daten.passwort}</dd>
            </dl>
            <p className="klein leise" style={{ marginTop: "var(--luft-3)" }}>
              Gib das Passwort niemandem weiter. Wer es hat, liest deine Chats mit — und ändern
              kannst du es nicht selbst.
            </p>
          </>
        )}
      </div>
    </Abschnitt>
  );
}


/*
  Die eigenen Geräte.

  Warum das nicht nur Zierde ist: Unser Server verwahrt das Matrix-Passwort
  jedes Mitglieds — sonst müsste sich jeder zweimal anmelden. Damit könnte er
  sich als jemand ausgeben und künftige Beiträge mitlesen.

  Heimlich ginge das aber nicht: Dabei entstünde ein Gerät, und es stünde
  hier, unbestätigt. Diese Liste ist der Grund, warum „der Server kann nicht
  mitlesen" mehr ist als ein Versprechen — man kann es nachsehen.
*/
function MeineGeraete() {
  const chat = useChat();
  const [geraete, setzeGeraete] = useState(null);
  const [fehler, setzeFehler] = useState("");

  async function laden() {
    setzeFehler("");
    try {
      setzeGeraete(await chat.meineGeraete());
    } catch (f) {
      setzeFehler(f.message || "Die Geräte ließen sich nicht laden.");
    }
  }

  async function abmelden(id) {
    try {
      await chat.geraetAbmelden(id);
      await laden();
    } catch (f) {
      setzeFehler(
        "Das Gerät ließ sich nicht abmelden. " + (f.message || "")
      );
    }
  }

  return (
    <Abschnitt
      titel="Meine Geräte"
      hinweis="Überall dort, wo du den Chat geöffnet hast. Ein Gerät, das du nicht kennst, gehört abgemeldet."
    >
      <div className="karte">
        {!geraete ? (
          <button className="knopf knopf--zurueckhaltend" onClick={laden} disabled={!chat.bereit}>
            {chat.bereit ? "Geräte anzeigen" : "Chat wird noch verbunden …"}
          </button>
        ) : geraete.length === 0 ? (
          <p className="leise">Keine Geräte gefunden.</p>
        ) : (
          <ul className="geraete">
            {geraete.map((g) => (
              <li key={g.id} className="geraet">
                <span className="geraet__haupt">
                  <span className="geraet__name">
                    {g.name}
                    {g.dieses && <span className="marke marke--betont">Dieses Gerät</span>}
                  </span>
                  <span className="klein leise">
                    {g.zuletzt ? `Zuletzt ${kurzesDatum(g.zuletzt)}, ${uhrzeit(g.zuletzt)}` : "Noch nie benutzt"}
                    {" · "}
                    {g.bestaetigt ? "bestätigt" : "nicht bestätigt"}
                  </span>
                </span>
                {!g.dieses && (
                  <button className="knopf knopf--schlicht" onClick={() => abmelden(g.id)}>
                    Abmelden
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}

        {fehler && (
          <p className="klein" style={{ color: "var(--ampel-nein)", marginTop: "var(--luft-3)" }}>
            {fehler}
          </p>
        )}
      </div>
    </Abschnitt>
  );
}

/* ---------------------------------------------------------------
   Kalenderabo
   --------------------------------------------------------------- */

/*
  Sitzungen und Termine im eigenen Handykalender.

  Der Weg ist ein Abo: Das Fraktionsbüro veröffentlicht eine geheime
  Adresse, Apple Kalender, Google Kalender und Outlook holen sie sich
  regelmäßig. Kein Google-Konto, kein Prüfverfahren, keine fremden
  Zugangsschlüssel auf unserem Server — und für alle drei derselbe Weg.

  Die Adresse ist der Ausweis. Wer sie hat, liest die Termine mit. Das steht
  deshalb hier und nicht im Kleingedruckten, und daneben steht der Knopf,
  der eine weitergegebene Adresse entwertet.

  Umgekehrt geht es nicht: Private Termine aus Google im Fraktionsbüro zu
  sehen bräuchte eine Anmeldung bei Google samt Prüfverfahren. Siehe
  VEREINFACHUNGEN.md.
*/
function Kalenderabo() {
  const { token } = useAnmeldung();
  const [schluessel, setzeSchluessel] = useState(null);
  const [fehler, setzeFehler] = useState(null);
  const [kopiert, setzeKopiert] = useState(false);
  const [laeuft, setzeLaeuft] = useState(false);

  useEffect(() => {
    let abgebrochen = false;
    holeKalenderadresse(token)
      .then((s) => !abgebrochen && setzeSchluessel(s))
      .catch((f) => !abgebrochen && setzeFehler(f.message));
    return () => {
      abgebrochen = true;
    };
  }, [token]);

  const adresse = schluessel
    ? `${window.location.origin}/api/fb/kalender/${schluessel}.ics`
    : "";
  /* webcal:// öffnet auf iPhone und Mac unmittelbar den Abo-Dialog. */
  const webcal = adresse.replace(/^https?:/, "webcal:");

  async function neu() {
    if (!window.confirm("Die bisherige Adresse gilt danach nicht mehr. Fortfahren?")) return;
    setzeLaeuft(true);
    try {
      setzeSchluessel(await erneuereKalenderadresse(token));
      setzeKopiert(false);
    } catch (f) {
      setzeFehler(f.message);
    } finally {
      setzeLaeuft(false);
    }
  }

  return (
    <Abschnitt
      titel="Kalender aufs Handy"
      hinweis="Sitzungen und deine Termine im Kalender von Apple, Google oder Outlook."
    >
      <div className="karte">
        {fehler && <p className="klein" style={{ color: "var(--ampel-nein)" }}>{fehler}</p>}

        {!schluessel && !fehler && <p className="klein leise">Wird geholt …</p>}

        {schluessel && (
          <>
            <p className="kalenderabo__adresse">{adresse}</p>

            <div className="leiste__knoepfe" style={{ marginTop: "var(--luft-3)" }}>
              <button
                className="knopf"
                onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(adresse);
                    setzeKopiert(true);
                  } catch {
                    setzeKopiert(false);
                  }
                }}
              >
                {kopiert ? "Kopiert" : "Adresse kopieren"}
              </button>

              <a className="knopf knopf--zurueckhaltend" href={webcal}>
                In den Kalender eintragen
              </a>
            </div>

            <p className="klein leise" style={{ marginTop: "var(--luft-4)" }}>
              <strong>Behandle diese Adresse wie ein Passwort.</strong> Wer sie hat,
              sieht deine Sitzungen und Termine — eine Anmeldung braucht es dafür
              nicht, denn ein Kalenderprogramm kann sich nicht anmelden.
            </p>

            <p className="klein leise" style={{ marginTop: "var(--luft-2)" }}>
              Im Handykalender lässt sich nur lesen. Eingetragen wird im Fraktionsbüro.
            </p>

            <button
              className="knopf knopf--schlicht"
              style={{ marginTop: "var(--luft-3)", paddingLeft: 0 }}
              onClick={neu}
              disabled={laeuft}
            >
              {laeuft ? "Wird erzeugt …" : "Neue Adresse erzeugen"}
            </button>
          </>
        )}
      </div>
    </Abschnitt>
  );
}
